import { authenticationFingerprint } from "./authSession";

let cached = null;
export function readCandidateListCache() {
  const session = authenticationFingerprint();
  if (!session || cached?.session !== session || Date.now() - cached.at > 60000) return null;
  return cached.rows;
}
export function writeCandidateListCache(rows, session) {
  if (session && session === authenticationFingerprint()) cached = { rows, session, at: Date.now() };
}
